import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Href } from 'components/ui/Href/Href'
import { Flex, Text } from 'components/uiKit'
import { PromoRoutesEnum } from 'shared/constants/routes'

export const ELockOrderText = () => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <Flex vertical gap={16}>
      <>
        <Flex vertical>
          <Text>{t(getKey('На данном этапе вам необходимо'))}</Text>
        </Flex>

        <Flex vertical>
          <Text>{t(getKey('Если вы установили замок'))}</Text>
        </Flex>

        <Flex vertical>
          <Text>{t(getKey('В исключительных случаях'))}</Text>
        </Flex>

        <Flex vertical>
          <Text>
            {t(getKey('Если у вас есть вопросы'))} <Href href={PromoRoutesEnum.apps}>WB Point</Href>.
          </Text>
        </Flex>
      </>
    </Flex>
  )
}
